var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVersus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 19,
    viewBox: "0 0 11 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9414 7.18308L9.76641 6.00808L5.94141 9.82475L2.11641 6.00808L0.941406 7.18308L5.94141 12.1831L10.9414 7.18308Z",
    fill: "#1F1F1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9414 13.0248L9.76641 11.8498L5.94141 15.6664L2.11641 11.8498L0.941406 13.0248L5.94141 18.0248L10.9414 13.0248Z",
    fill: "#1F1F1F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9414 1.49977L9.76641 0.324768L5.94141 4.14143L2.11641 0.324768L0.941406 1.49977L5.94141 6.49977L10.9414 1.49977Z",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVersus);
export default __webpack_public_path__ + "static/media/versus.15348abf94bef6bf39cc9f8f6e7077e4.svg";
export { ForwardRef as ReactComponent };